// Simple Angular environment configuration for development
export const environment = {
  pricingApiBaseUrl: 'https://api.dev.aktok.com/api'
};